// @flow
import * as React from 'react';
import Modal from 'react-modal';

import { withRouter } from 'app/context/Router.jsx';
import AdminAutoMessagesContainer from './AdminAutoMessagesContainer.jsx';
import AdminAutoMessagesView from './AdminAutoMessagesView.jsx';
import AdminNewAutoMessageModal from 'admin/components/AdminNewAutoMessage';

type Props = {
  organizationUUID: string,
  params: {
    groupCode: string,
  },
};

type State = {
  isNewAutoMessageDialogOpened: boolean,
};

class AdminAutoMessages extends React.Component<Props, State> {
  state = {
    isNewAutoMessageDialogOpened: false,
  };

  toggleNewAutoMessageDialog = () => {
    this.setState({ isNewAutoMessageDialogOpened: !this.state.isNewAutoMessageDialogOpened });
  };

  render() {
    const {
      organizationUUID,
      params: { groupCode },
    } = this.props;
    const urlSlug = `/classes/${groupCode}/settings/organization/auto_messages`;

    return (
      <React.Fragment>
        <Modal isOpen={this.state.isNewAutoMessageDialogOpened}>
          <AdminNewAutoMessageModal
            onBack={this.toggleNewAutoMessageDialog}
            organizationUUID={organizationUUID}
          />
        </Modal>
        <AdminAutoMessagesContainer organizationUUID={organizationUUID}>
          {props => (
            <AdminAutoMessagesView
              {...props}
              onClickNewAutoMessage={this.toggleNewAutoMessageDialog}
              urlSlug={urlSlug}
            />
          )}
        </AdminAutoMessagesContainer>
      </React.Fragment>
    );
  }
}

export default withRouter(AdminAutoMessages);
